var map = {
  "./desktop/Toiflipbook.scss": [
    "6625",
    7,
    "37090"
  ],
  "./desktop/index.js": [
    "41549",
    9,
    "76225",
    "62815",
    "88787",
    "7979",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "74336",
    "4686"
  ],
  "./desktop/index": [
    "41549",
    9,
    "76225",
    "62815",
    "88787",
    "7979",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "74336",
    "4686"
  ],
  "./mobile/Toiflipbook": [
    "22659",
    9,
    "88787",
    "78469"
  ],
  "./mobile/index.js": [
    "84473",
    9,
    "88787",
    "23880",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "74336",
    "45322"
  ],
  "./mobile/Toiflipbook.scss": [
    "66083",
    7,
    "87446"
  ],
  "./mobile": [
    "84473",
    9,
    "88787",
    "23880",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "74336",
    "45322"
  ],
  "./desktop": [
    "41549",
    9,
    "76225",
    "62815",
    "88787",
    "7979",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "74336",
    "4686"
  ],
  "./desktop/": [
    "41549",
    9,
    "76225",
    "62815",
    "88787",
    "7979",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "74336",
    "4686"
  ],
  "./mobile/": [
    "84473",
    9,
    "88787",
    "23880",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "74336",
    "45322"
  ],
  "./desktop/Toiflipbook.js": [
    "61167",
    9,
    "88787",
    "40993"
  ],
  "./mobile/index": [
    "84473",
    9,
    "88787",
    "23880",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "74336",
    "45322"
  ],
  "./desktop/Toiflipbook": [
    "61167",
    9,
    "88787",
    "40993"
  ],
  "./mobile/Toiflipbook.js": [
    "22659",
    9,
    "88787",
    "78469"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 14659;
module.exports = __rspack_async_context;
